import * as React from 'react';
import { useAdapterContext } from "../../use-adapter-context/index.mjs";
// Fixed 24h grid (visual time, not real-time duration)
const FIXED_24H_GRID_MINUTES = 24 * 60;
export function useElementPositionInCollection(parameters) {
  const {
    start,
    end,
    collectionStart,
    collectionEnd
  } = parameters;
  const adapter = useAdapterContext();
  return React.useMemo(() => {
    const startDayIndex = adapter.differenceInDays(adapter.startOfDay(start.value), adapter.startOfDay(collectionStart));
    const endDayIndex = adapter.differenceInDays(adapter.startOfDay(end.value), adapter.startOfDay(collectionStart));
    const startIndexMinutes = startDayIndex * FIXED_24H_GRID_MINUTES + start.minutesInDay;
    let endIndexMinutes = endDayIndex * FIXED_24H_GRID_MINUTES + end.minutesInDay;

    // If the event ends before it starts, it means it spans over midnight(s)
    if (endIndexMinutes < startIndexMinutes) {
      endIndexMinutes += FIXED_24H_GRID_MINUTES;
    }
    const totalDays = adapter.differenceInDays(adapter.startOfDay(collectionEnd), adapter.startOfDay(collectionStart)) + 1;
    const totalMinutes = Math.max(1, totalDays * FIXED_24H_GRID_MINUTES);
    const clampToTimeline = value => Math.min(Math.max(value, 0), totalMinutes);
    const clampedStartMinutes = clampToTimeline(startIndexMinutes);
    const clampedEndMinutes = clampToTimeline(endIndexMinutes);
    const startingBeforeEdge = startIndexMinutes < 0;
    const endingAfterEdge = endIndexMinutes > totalMinutes;
    return {
      position: clampedStartMinutes / totalMinutes,
      duration: Math.max(0, clampedEndMinutes - clampedStartMinutes) / totalMinutes,
      startingBeforeEdge,
      endingAfterEdge
    };
  }, [adapter, start, end, collectionStart, collectionEnd]);
}